import React from 'react';
import classnames from 'classnames';

import Capitals from './Capitals';
import CallControl from './CallControl';

import { trunc } from '../../../helpers/index';


import { Link } from 'react-router';

export default function CustomerHeader(props) {
  const {
    activeCallCreatedAndRunning,
    activeCallFetching,
    call,
    connected,
    customer,
    handleCreateSMS,
    handleStopCall,
    openCallBeginModal,
    selectedOrderId,
    couldNotCreateCall,
    company
  } = props;

  return (
    <div className="video-chat-header" style={{ minWidth: 0 }}>
      <div className="video-chat-header-left-col" style={{ marginTop: 0, display: 'flex', alignItems: 'center', minWidth: 0, flexShrink: 1 }}>
        <div className="customer-single-element" style={{ minWidth: 0, flexShrink: 1, display: 'flex', alignItems: 'center' }}>
          <div className="customer-single-element-capitals hidden-xs hidden-sm" style={{ flexShrink: 0 }}>
            <Capitals customer={customer} />
          </div>
          <div className="customer-single-element-right" style={{ minWidth: 0, flexShrink: 1, marginLeft: customer.name ? '20px' : 0 }}>
            {customer.name ? (
              <h4 
                className="customer-sub-title" 
                style={{ 
                  whiteSpace: 'nowrap', 
                  overflow: 'hidden', 
                  textOverflow: 'ellipsis', 
                  maxWidth: (activeCallCreatedAndRunning && call && !call.call_end) ? '120px' : '220px', 
                  display: 'block',
                  margin: 0
                }}
                title={customer.name}
              >
                {customer.name}
              </h4>
            ) : null}
            <div 
              className="customer-list-row-text-small" 
              style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} 
              title={customer.deleted || customer.phone}
            >
              {customer.deleted || customer.phone}
            </div>
          </div>
        </div>
      </div>
      {(activeCallFetching || couldNotCreateCall) ? null : (
        <CallControl
          activeCallCreatedAndRunning={activeCallCreatedAndRunning}
          call={call}
          handleStopCall={handleStopCall}
          handleCreateSMS={handleCreateSMS}
          customerSlug={customer.slug}
          openCallBeginModal={openCallBeginModal}
          customer={customer}
          selectedOrderId={selectedOrderId}
          company={company}
        />
      )}
    </div>
  );
}
